import * as Popover from '@radix-ui/react-popover';
import { AnimatePresence } from 'framer-motion';
import { MessageCircleQuestion } from 'lucide-react';
import { useState } from 'react';

import { tv } from '@/utils/styles';

import { ExtraNavButton, extraNavButtonStyles } from '../extra-nav-button';
import { AppNavigationHelpDropdown } from '../help-dropdown';

interface AppNavigationHelpPopoverProps {
  visibility: string;
}

const AppNavigationHelpPopover = ({ visibility }: AppNavigationHelpPopoverProps) => {
  const [popoutIsOpen, setPopoutIsOpen] = useState<boolean>(false);

  const { trigger, popoverContent } = styles();
  const { toggleButton } = extraNavButtonStyles();

  return (
    <Popover.Root onOpenChange={() => setPopoutIsOpen(!popoutIsOpen)}>
      <Popover.Trigger className={trigger()}>
        <ExtraNavButton
          as="span"
          buttonText="Support / Feedback"
          icon={<MessageCircleQuestion size={18} />}
          visibility={visibility}
          className={toggleButton({ className: 'before:hidden' })}
        />
      </Popover.Trigger>

      <AnimatePresence>
        {popoutIsOpen && (
          <Popover.Portal>
            <Popover.Content sideOffset={4} forceMount side="top" align="start" className={popoverContent()}>
              <AppNavigationHelpDropdown isOpen={popoutIsOpen} />
            </Popover.Content>
          </Popover.Portal>
        )}
      </AnimatePresence>
    </Popover.Root>
  );
};

export const styles = tv({
  slots: {
    base: 'w-full',
    trigger: 'block w-full',
    popoverContent: 'relative z-10',
  },
});

export { AppNavigationHelpPopover };
